import React from 'react';
import { ZALO_LINK } from '../constants/links';
import Picture from './Picture';

const iconProps = {
  'aria-hidden': true,
  width: 22,
  height: 22,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

const TRUST_ITEMS = [
  {
    title: 'Giao hàng toàn quốc',
    text: 'Đóng gói kỹ, tem nhãn đầy đủ',
    icon: (
      <svg {...iconProps}>
        <path d="M3 7h11v9H3z" /><path d="M14 10h4l3 3v3h-7" /><circle cx="7" cy="18" r="1.8" /><circle cx="17" cy="18" r="1.8" />
      </svg>
    ),
  },
  {
    title: 'Sản xuất tại Đà Lạt',
    text: 'Yên Khê Hạ, Lạc Lâm, Đơn Dương',
    icon: (
      <svg {...iconProps}>
        <path d="M4 20V10l8-6 8 6v10" /><path d="M9 20v-6h6v6" />
      </svg>
    ),
  },
  {
    title: 'Chiết khấu sỉ 20–35%',
    text: 'Hỗ trợ in tem nhãn riêng',
    icon: (
      <svg {...iconProps}>
        <path d="M20 12l-8 8-8-8 8-8h6a2 2 0 0 1 2 2z" /><circle cx="15.5" cy="8.5" r="1.3" />
      </svg>
    ),
  },
  {
    title: 'Mở cửa mỗi ngày',
    text: '8:00 – 21:00, thứ 2 – chủ nhật',
    icon: (
      <svg {...iconProps}>
        <circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" />
      </svg>
    ),
  },
];

function BusinessIntro() {
  return (
    <>
      <section id="about" className="bg-forest text-white">
        <div className="page-container flex flex-wrap items-center gap-14 pb-[88px] pt-[72px]">
          <div className="flex min-w-0 flex-[1_1_480px] flex-col gap-6">
            <span className="self-start rounded-full bg-gold/[0.14] px-3.5 py-1.5 text-[13px] font-semibold uppercase tracking-[0.06em] text-gold">
              Làm tại Đơn Dương, Lâm Đồng
            </span>
            <h1 className="m-0 font-display text-[clamp(2.6rem,5vw,4.4rem)] font-extrabold leading-[1.02] tracking-[-0.025em]">
              Bánh tráng <span className="text-gold">mắm ruốc Đà Lạt</span> giòn rụm, đậm vị.
            </h1>
            <p className="m-0 max-w-[34rem] text-lg text-mist">
              Chuyên sản xuất và phân phối <strong className="font-semibold text-white">bánh tráng mắm ruốc</strong>,{' '}
              <strong className="font-semibold text-white">bánh tráng sa tế tôm</strong> đặc sản Đà Lạt. Công thức riêng,
              nguyên liệu chọn lọc — phục vụ khách sỉ và lẻ trên toàn quốc.
            </p>
            <div className="flex flex-wrap gap-3 pt-2">
              <a
                href={ZALO_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-lg bg-accent text-white hover:bg-accent-dark hover:text-white"
              >
                Đặt hàng qua Zalo
                <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12h14" /><path d="M13 6l6 6-6 6" />
                </svg>
              </a>
              <a href="#menu" className="btn btn-lg border-[1.5px] border-white/35 font-semibold text-white hover:border-white hover:text-white">
                Xem bảng giá
              </a>
            </div>
          </div>

          <div className="flex min-w-0 flex-[1_1_420px] gap-4">
            <div className="relative h-[340px] min-w-0 flex-[3_1_0] overflow-hidden rounded-[28px] bg-[#E9C58A] sm:h-[460px]">
              <Picture
                path="hero/slide1"
                alt="Bánh tráng mắm ruốc nướng giòn - Đặc sản Đà Lạt Gà Kitchen"
                width={1200}
                height={900}
                eager
                className="h-full w-full object-cover"
              />
            </div>
            <div className="flex min-w-0 flex-[2_1_0] flex-col gap-4">
              <div className="min-h-0 flex-1 overflow-hidden rounded-3xl bg-[#D98B4A]">
                <Picture
                  path="products/banh-trang-sate-tom-180"
                  alt="Bánh tráng sa tế tôm - Đặc sản Đà Lạt Gà Kitchen"
                  width={900}
                  height={675}
                  className="h-full w-full object-cover"
                />
              </div>
              <div className="min-h-0 flex-1 overflow-hidden rounded-3xl bg-[#F2D9A0]">
                <Picture
                  path="products/banh-phong-chuoi-5"
                  alt="Bánh phồng chuối nướng - Đặc sản Đà Lạt Gà Kitchen"
                  width={900}
                  height={674}
                  className="h-full w-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section aria-label="Cam kết" className="bg-cream">
        <div className="page-container grid grid-cols-[repeat(auto-fit,minmax(220px,1fr))] gap-5 py-7">
          {TRUST_ITEMS.map((item) => (
            <div key={item.title} className="flex items-center gap-3.5">
              <span className="flex h-11 w-11 flex-none items-center justify-center rounded-xl bg-white text-forest">
                {item.icon}
              </span>
              <span className="flex flex-col leading-[1.35]">
                <strong className="text-[15px]">{item.title}</strong>
                <span className="text-sm text-muted">{item.text}</span>
              </span>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}

export default BusinessIntro;
